import { ChangeEvent } from "react"

type TextFormInputProps =  {
    id: string | undefined
    value?: string
    placeholder: string
    textValidationMessage: string | ""
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export default function TextFormInput(props: TextFormInputProps) {    
    const { id, value, placeholder, textValidationMessage, onChange } = props
    
    return (
        <div className="text-left my-6">
            <input
                id={id}
                type="text"
                placeholder={placeholder}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300"
                onChange={onChange}
                value={value}
            />
            { textValidationMessage && <span className="text-red-600">{textValidationMessage}</span> }
        </div>
    )
}